import axios from './AxiosConfig';
import config from 'config';
import store from './../stores';
import moment from 'moment';

import {
  customerJourneyAttractionsError,
  customerJourneyAttractionsSuccess,
  customerJourneyCategoriesError,
  customerJourneyCategoriesSuccess,
  customerJourneyEventsCategoriesError,
  customerJourneyEventsCategoriesSuccess,
  customerJourneyEventsCategoryError,
  customerJourneyEventsCategorySuccess,
  customerJourneyHotelError,
  customerJourneyHotelSuccess,
  customerJourneyLoginError,
  customerJourneyLoginReservationError,
  customerJourneyLoginReservationSuccess,
  customerJourneyLoginSuccess,
  customerJourneyMailUnsubscribeError,
  customerJourneyMailUnsubscribeSuccess,
  customerJourneyMenuError,
  customerJourneyMenuSuccess,
  customerJourneyNewsCategoriesError,
  customerJourneyNewsCategoriesSuccess,
  customerJourneyNewsCategoryError,
  customerJourneyNewsCategorySuccess,
  customerJourneyReservationError,
  customerJourneyReservationSuccess,
  customerJourneyServicesBookError,
  customerJourneyServicesBookSuccess,
  customerJourneyServicesError,
  customerJourneyServicesSuccess,
  customerJourneyVenuesError,
  customerJourneyVenuesSuccess,
  customerJourneyWeatherError,
  customerJourneyWeatherSuccess,
  duringStaySurveyGetAnswerError,
  duringStaySurveyGetAnswerSuccess,
  duringStaySurveySendAnswerError,
  duringStaySurveySendAnswerSuccess
} from './../actions';

const baseUrl = config.apiBaseUrl;
const apiMock = config.apiMock;

if (apiMock) {
  /* Mock calls remove for real behaviour */
  require('./mocks/ApiMock');
}

const getHeaders = (lang, context) => {

  let headers = {
    'Accept': 'application/json',
    'Accept-Language': lang
  };

  switch (context) {
    case 'hotel':
      headers['TravelAppeal-Context'] = 'token';
      headers['Authorization'] = `Token ${config.travelAppealTokenId}`;
      break;
    case 'public':
      /* Not handled yet... */
      break;
  }

  return headers;
};

const wrappedFetch = (url, config) => {
  if (apiMock) {
    return axios.get(url, config)
      .then(response => response.data);
  } else {
    // return fetch(url, config)
    //   .then(response => response.json());

    return fetch(url, config)
      .then(response => {
        if (response.status >= 400 && response.status < 500) {
          window.location.href = 'https://bestwestern.it';
          return;
        }
        return response.json();
      });
  };
}

const CustomerJourneySource = {
  hotel: (token, lang, context = null) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/hotel?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyHotelSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyHotelError());
        // store.dispatch(postError(response.message));
      });
  },
  reservation: (token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/reservation?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyReservationSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyReservationError());
        // store.dispatch(postError(response.message));
      });
  },
  categories: (token, lang, successCallback, errorCallback, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/categories?format=json&token=${token}`, config)
    // return wrappedFetch(`${baseUrl}/400`, config)
      .then(function (response) {
        store.dispatch(customerJourneyCategoriesSuccess(response, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyCategoriesError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  eventsCategories: (token, lang, successCallback, errorCallback, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/eventsCategories?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyEventsCategoriesSuccess(response, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyEventsCategoriesError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  eventsCategory: (catId, token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/events?format=json&token=${token}&cat_id=${catId}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyEventsCategorySuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyEventsCategoryError());
        // store.dispatch(postError(response.message));
      });
  },
  attractions: (token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/attractions?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyAttractionsSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyAttractionsError());
        // store.dispatch(postError(response.message));
      });
  },
  menu: (token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/menu?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyMenuSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyMenuError());
        // store.dispatch(postError(response.message));
      });
  },
  venues: (token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/venues?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyVenuesSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyVenuesError());
        // store.dispatch(postError(response.message));
      });
  },
  services: (catId, token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/services?format=json&token=${token}&cat_id=${catId}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyServicesSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyServicesError());
        // store.dispatch(postError(response.message));
      });
  },
  servicesBook: (serviceId, token, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    const data = {
      service_id: serviceId
    };

    return axios.put(`${baseUrl}/services?format=json&token=${token}`, data, config)
      .then(function (response) {
        store.dispatch(customerJourneyServicesBookSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyServicesBookError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  login: (reservationId, surname, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    const data = {
      reservation_id: reservationId,
      surname: surname
    };

    return axios.post(`${baseUrl}/login?format=json`, data, config)
      .then(function (response) {
        store.dispatch(customerJourneyLoginSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyLoginError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  loginReservation: (checkInDate, checkOutDate, surname, token, lang, successCallback, errorCallback, context = false) => {
    debugger
    const config = {
      headers: getHeaders(lang, context)
    };

    const data = {
      checkin: moment(checkInDate)
        .format('YYYY-MM-DD'),
      checkout: moment(checkOutDate)
        .format('YYYY-MM-DD'),
      surname: surname
    };

    return axios.post(`${baseUrl}/reservation?format=json&token=${token}`, data, config)
      .then(function (response) {
        store.dispatch(customerJourneyLoginReservationSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyLoginReservationError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  weather: (token, lang, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/weather?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyWeatherSuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyWeatherError());
        // store.dispatch(postError(response.message));
      });
  },
  subscribe_mail: (token, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    const data = {};

    return axios.put(`${baseUrl}/unsubscribe?format=json&token=${token}`, data, config)
      .then(function (response) {
        store.dispatch(customerJourneyMailUnsubscribeSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyMailUnsubscribeError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  unsubscribe_mail: (token, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    return axios.delete(`${baseUrl}/unsubscribe?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyMailUnsubscribeSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyMailUnsubscribeError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  newsCategories: (token, lang, successCallback, errorCallback, context = false) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/newsCategories?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyNewsCategoriesSuccess(response, successCallback));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyNewsCategoriesError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  newsCategory: (catId, token, lang, context = false, offset, limit) => {
    const config = {
      headers: getHeaders(lang, context)
    };

    return wrappedFetch(`${baseUrl}/news?format=json&token=${token}&cat_id=${catId}${(offset && limit) ? `&offset=${offset}&limit=${limit}` : ''}`, config)
      .then(function (response) {
        store.dispatch(customerJourneyNewsCategorySuccess(response));
      })
      .catch(function (response) {
        store.dispatch(customerJourneyNewsCategoryError());
        // store.dispatch(postError(response.message));
      });
  },
  duringStaySurvey_getAnswer: (token, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    return axios.get(`${baseUrl}/duringStaySurvey?format=json&token=${token}`, config)
      .then(function (response) {
        store.dispatch(duringStaySurveyGetAnswerSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        store.dispatch(duringStaySurveyGetAnswerError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  },
  duringStaySurvey_sendAnswer: (comment, vote, token, lang, successCallback, errorCallback) => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Accept-Language': lang
      }
    };

    return axios.put(`${baseUrl}/duringStaySurvey?format=json&token=${token}`, {
      comment,
      vote
    }, config)
      .then(function (response) {
        console.info('response', response);
        store.dispatch(duringStaySurveySendAnswerSuccess(response.data, successCallback));
      })
      .catch(function (response) {
        console.error('error', response);
        store.dispatch(duringStaySurveySendAnswerError(errorCallback));
        // store.dispatch(postError(response.message));
      });
  }
};

export default CustomerJourneySource;



// WEBPACK FOOTER //
// ./sources/CustomerJourneySource.js